$ = require 'jquery'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
xtend = require 'xtend'

module.exports = class HeaderVersionPicker extends View
  viewTitleKey: 'select client version'

  LATEST_VERSION: { '0.0': true }

  events:
    'change .js-select-head': 'updateHead'
    'change .js-select-version': 'updateVersion'

  initialize: ->
    @active = (try JSON.parse($.cookie('head'))) || {}
    # We only ever use the version as a display/comparator, so we can combine
    # the version and patch to a string
    if @active.version
      @active.version = [@active.version ? 0, @active.patch ? 0].join('.')

    $.getJSON '/web/deployments'
    .done (data) =>
      @deployments = data
      @render()

  render: ->
    if @deployments?
      @$el.html templates.fill 'header_version_picker',
        active: @formatActive()
        heads: [null].concat(@listHeads())
        versions: [null].concat(@listVersions())
    else
      @$el.text "Loading..."
    @

  formatVersion: (v) ->
    if v == '0.0'
      'latest'
    else
      v

  formatActive: ->
    name: @active.name
    version: @formatVersion(@active.version)

  listHeads: ->
    for head, versions of @deployments
      displayName: head
      value: head
      selected: @active.name == head

  listVersions: ->
    deployments = @deployments[@active.name]
    for version, active of xtend(@LATEST_VERSION, deployments)
      displayName: @formatVersion(version)
      value: version
      selected: @active.version == version
      active: active

  updateHead: (e) ->
    @active.name = $(e.target).val()
    # If we previously had a version, that no longer applies
    @active.version = null
    @render()

  updateVersion: (e) ->
    @active.version = $(e.target).val()
    # Render for visual effect if the reload is slow
    @render()
    [version, patch] = @active.version.split('.')
    cookie = { name: @active.name, version, patch }

    # Stop if we picked the blank item.
    return unless parseInt(version) >= 0

    $.cookie('head', JSON.stringify(cookie), { path: '/' })
    document.location.reload()



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-version-picker.coffee